import { useLessonCalendarStore } from '../store/lessonCalendar';
import { invalidateAcademyScopedQueries } from './invalidateAcademyQueries';

/**
 * Run when the active academy changes: drop previous academy's React Query cache
 * and reset the lesson calendar Zustand store so schedule views cannot show stale data.
 */
export function onAcademyContextSwitch(
  previousAcademyId: string | null | undefined,
  nextAcademyId: string | null | undefined
): void {
  if (previousAcademyId && nextAcademyId !== previousAcademyId) {
    invalidateAcademyScopedQueries(previousAcademyId);
  }

  if (nextAcademyId && previousAcademyId !== nextAcademyId) {
    useLessonCalendarStore.getState().resetForAcademy(nextAcademyId);
  } else if (!nextAcademyId) {
    useLessonCalendarStore.getState().clear();
  }
}
